import Notification from '@stimulus-components/notification'

export default class extends Notification {
    connect() {
        console.log("[NOTIFICATION_CONTROLLER] CONNECTED")
        super.connect()
    }
}